<p-dialog [(visible)]="itemSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw', height: '90vh' }" (onHide)="onClose()">
	<div *ngIf="itemSelected">
		<p-tabView [scrollable]="true">
			<p-tabPanel [header]="canvas.displayName || canvas.name" *ngFor="let canvas of itemSelected.ooMenuItem.canvases; let i = index" [selected]="i == 0">
				<app-pos-canvas-items [canvasSelected]="canvas"></app-pos-canvas-items>
			</p-tabPanel>
		</p-tabView>
	</div>
</p-dialog>
